/**
 * Helpers de validación de rango de fechas (frontend).
 *
 * Las consultas por rango se limitan a 3 meses para proteger rendimiento en producción.
 * No ampliar este límite sin implementar paginación/exportación controlada e índices adecuados.
 */

export const RANGO_MAX_DIAS = 92;

export const MENSAJE_RANGO_EXCEDIDO =
  'El rango máximo permitido es de 3 meses. Reduzca el rango de fechas para continuar.';

/**
 * Valida un rango de fechas en formato YYYY-MM-DD (ISO local).
 * Retorna mensaje de error o null si el rango es válido / vacío.
 */
export function validarRangoFechas(
  fechaInicio: string | null | undefined,
  fechaFin: string | null | undefined,
  maxDias: number = RANGO_MAX_DIAS,
): string | null {
  if (!fechaInicio || !fechaFin) return null;
  const ini = new Date(`${fechaInicio}T00:00:00`);
  const fin = new Date(`${fechaFin}T00:00:00`);
  if (Number.isNaN(ini.getTime()) || Number.isNaN(fin.getTime())) return null;
  if (ini > fin) return 'La fecha inicial no puede ser mayor que la final.';
  const dias = Math.round((fin.getTime() - ini.getTime()) / (1000 * 60 * 60 * 24));
  if (dias > maxDias) return MENSAJE_RANGO_EXCEDIDO;
  return null;
}
